import type { Dispatch } from "react";
import { useEffect, useMemo } from "react";

import { getIsRTCreateCampaignsAvailable } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsInfraUtils";
import type { RTContextState } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import { ECampaignsLoadingState } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import type { RTContextActions } from "app/pages/digital-marketing/keywords-campaigns/infra/RTContext.consts";
import { ERTContextReducerTypes } from "app/pages/digital-marketing/keywords-campaigns/infra/RTContext.consts";

export function useLoadingState(
    state: RTContextState,
    dispatch: Dispatch<RTContextActions>,
    isLoadingDemoCampaigns: boolean,
    updateCampaignsFromServer: () => Promise<void>,
) {
    const { campaignsConfigurations, loadingState } = state;

    const isLoaded = useMemo(() => {
        const areCampaignsLoaded = getIsRTCreateCampaignsAvailable() ? !!campaignsConfigurations : true;
        return areCampaignsLoaded && !isLoadingDemoCampaigns;
    }, [campaignsConfigurations, isLoadingDemoCampaigns]);

    useEffect(() => {
        if (!isLoaded) {
            void updateCampaignsFromServer();
        } else if (loadingState !== ECampaignsLoadingState.ERROR) {
            dispatch({
                type: ERTContextReducerTypes.UpdateLoadingState,
                payload: { loadingState: ECampaignsLoadingState.DONE },
            });
        }
    }, [dispatch, isLoaded, updateCampaignsFromServer]);
}
